@if (displayPromo && !hideStickyBanner) {
  <div
    [ngClass]="!displayRE ? 'hidden' : ''"
    [className]="theme?.root + ' bg-no-repeat bg-center bg-cover'"
    id="graphicBanner"
    [style]="!isResponsiveMode ? theme?.bgImage : ''"
    [style.backgroundColor]="pageData?.altBgColor?.length > 0 ? pageData.altBgColor + ' !important' : null"
    >
    <!-- RESPONSIVE MODE: Multiple assets in backgroundImage -->
    @if (isResponsiveMode && responsiveImages) {
      <div class="w-full">
        <picture class="block w-full ">
          <source media="(min-width: 1440px)" [srcset]="responsiveImages.xl" />
          <source media="(min-width: 1024px)" [srcset]="responsiveImages.lg" />
          <source media="(min-width: 768px)" [srcset]="responsiveImages.md" />
          <source media="(min-width: 600px)" [srcset]="responsiveImages.sm" />
          <img [src]="responsiveImages.xs" [alt]="responsiveAltText" height="186" class="mx-auto  max-w-[1440px] w-full" fetchpriority="high" preloadImg />
        </picture>
      </div>
    }
    <!-- NORMAL MODE: Traditional layout with image + content -->
    @if (!isResponsiveMode) {
      <div class="container !px-4 {{ theme?.container }}">
        <div class="flex gap-4 {{imageAlignment}} items-center mx-auto xs:flex xs:gap-0 max-w-[920px]">
          @if (image) {
            <div
              class="w-full h-[stretch] xs:min-w-[220px] xs:w-auto graphic-banner__img">
              <img
                [src]="pageData.image[0].url"
                [alt]="pageData.image[0].altText"
                class="w-full h-full object-cover xs:object-none"
                width="210"
                height="160"
                fetchpriority="high"
                preloadImg
                />
            </div>
          }
          <div
        class="py-6 flex flex-col graphic-banner__content w-full sm:p-v-spacing
          {{ image && imageAlignment?.includes('justify-center') ? 'max-w-full' : 'w-full' }}"
            [innerHTML]="content"
            >
          </div>
        </div>
      </div>
    }
  </div>
}
